import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-billings',
    templateUrl: './billings.component.html',
    styleUrls: ['./billings.component.scss'],
    standalone: false
})
export class BillingsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
